<template>
  <div class="app-container">
    <el-card class="mb5">
    <el-form
      :key="tableKey" inline label-position="top"
      size="small"
    >
      <el-row
        :gutter="10" justify="flex-start" style="flex-wrap: wrap"
        type="flex"
      >
        <el-col v-if="searchProp.includes('status')" :span="5">
          <!--运单状态-->
          <el-form-item :label="$t('newOrder.waybillStatus')" style="width: 100%">
            <el-select
              v-model="queryForm.params.waybillStatus"
              :placeholder="$t('GlobalSetObj.all')"
              clearable
              collapse-tags
              filterable
              multiple
              size="small"
              style="width: 100%"
              @change="selectStatus"
            >
              <el-option
                v-for="item in waybillStatusList"
                :key="item.code"
                :label="item.label"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="searchProp.includes('customerName')" :span="5">
          <!--客户名称-->
          <el-form-item :label="$t('collectionCenter.CustomerName')" style="width: 100%">
            <el-select
              v-model="queryForm.params.customerIds"
              :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
              :remote-method="getCustomerPage"
              clearable
              filterable
              multiple
              remote
              reserve-keyword
              style="width: 100%"
              @clear="getCustomerPage('')"
              @focus="getCustomerPage('', true)"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.customerAlias + '(' + item.username + ')'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="searchProp.includes('merchantName')" :span="5">
          <!--  商户名称  -->
          <el-form-item
            :label="$t('collectionCenter.MerchantName')"
            prop="merchantCodeList"
            style="width: 100%"
          >
            <el-select
              v-model="queryForm.params.merchantCodeList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="getMerchantList"
              clearable
              collapse-tags
              filterable
              multiple
              remote
              reserve-keyword
              style="width: 100%"
              @clear="getMerchantList('')"
              @focus="getMerchantList('', true)"
            >
              <el-option
                v-for="item in merchantList"
                :key="item.id"
                :label="item.merchantName + '（' + item.merchantCode + '）'"
                :value="item.merchantCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-if="
            isArrayInclude(searchProp, [
              'preDeliverStationName',
              'deliverStationName',
              'warehouseStationName',
              'lastTrackSiteName'
            ])
          "
          :span="5"
        >
          <!--派送网点-->
          <el-form-item prop="siteDataId" style="width: 100%">
            <template slot="label">
              <div class="selectLabel">
                <el-select
                  v-model="queryForm.params.providerType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  @change="onProviderTypeChange"
                >
                  <!--预派送网点-->
                  <el-option
                    v-if="searchProp.includes('preDeliverStationName')"
                    key="1"
                    :label="$t('GlobalSetObj.preEntrega')"
                    :value="1"
                  />
                  <!--实际派送网点-->
                  <el-option
                    v-if="searchProp.includes('deliverStationName')"
                    key="2"
                    :label="$t('GlobalSetObj.entrega')"
                    :value="2"
                  />
                  <!--实际入库网点-->
                  <el-option
                    v-if="searchProp.includes('warehouseStationName')"
                    key="3"
                    :label="$t('GlobalSetObj.infeatSite')"
                    :value="3"
                  />
                  <!--最新轨迹网点-->
                  <el-option
                    v-if="searchProp.includes('lastTrackSiteName')"
                    key="4"
                    :label="$t('fixDutyFine.LatestTrackingBranch')"
                    :value="4"
                  />
                </el-select>
              </div>
            </template>
            <el-cascader
              v-model="queryForm.params.regionId"
              :options="regionList"
              :props="{
                value: 'id',
                label: 'name',
                children: 'sites',
                checkStrictly: true,
                multiple: true,
                expandTrigger: 'hover',
                size: 'mini'
              }"
              class="mini-filterable-cascader"
              clearable
              collapse-tags
              filterable
              size="mini"
              style="width: 100%"
              @change="hanleSiteId"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--   网点模式   -->
          <el-form-item :label="$t('GlobalSetObj.branchMode')" style="width: 100%">
            <el-select v-model="queryForm.params.siteBusinessModel" style="width: 100%">
              <el-option key="1" :label="$t('GlobalSetObj.all')" :value="null" />
              <el-option key="2" :value="1" label="直营(AJD)" />
              <el-option key="3" :value="2" label="加盟(DSP)" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!--   是否超时   -->
          <el-form-item :label="$t('orderCenterCont.TimeoutOrNot')" style="width: 100%">
            <el-select v-model="queryForm.params.isTimeOut" style="width: 100%">
              <el-option key="1" :label="$t('GlobalSetObj.all')" :value="-1" />
              <el-option key="2" :label="$t('GlobalSetObj.yes')" :value="1" />
              <el-option key="3" :label="$t('GlobalSetObj.No')" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!-- 发件人州 -->
          <el-form-item :label="$t('newOrder.SenderState')" style="width: 100%">
            <el-select
              v-model="queryForm.params.senderStateList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in StateList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="isArrayInclude(searchProp, ['receiveState', 'warehouseState'])" :span="5">
          <!--州-->
          <el-form-item prop="providerType" style="width: 100%">
            <template slot="label">
              <div class="selectLabel">
                <el-select
                  v-model="queryForm.params.stateType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :style="IsWidth"
                >
                  <!--收件人州-->
                  <el-option
                    v-if="searchProp.includes('receiveState')"
                    key="1"
                    :label="$t('newOrder.RecipientState')"
                    :value="0"
                  />
                  <!--实际入库网点州-->
                  <el-option
                    v-if="searchProp.includes('warehouseState')"
                    key="2"
                    :label="$t('GlobalSetObj.storageOutletsState')"
                    :value="1"
                  />
                </el-select>
              </div>
            </template>
            <el-select
              v-model="queryForm.params.stateList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in StateList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!--包裹类型-->
          <el-form-item :label="$t('placeOrder.packageType')" style="width: 100%">
            <el-select v-model="queryForm.params.orderPackageType" style="width: 100%">
              <el-option :label="$t('GlobalSetObj.all')" :value="null" />
              <el-option :label="$t('placeOrder.zhifa')" :value="1" />
              <el-option :label="$t('orderCenterCont.hedan')" :value="2" />
              <el-option :label="$t('GlobalSetObj.big01')" :value="4" />
              <el-option :label="$t('orderCenterCont.other')" :value="3" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="searchProp.includes('lostType')" :span="4">
          <!-- 标签 -->
          <el-form-item :label="$t('navbar.tag')" style="width: 100%">
            <el-select
              v-model="queryForm.params.lostType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              style="width: 100%"
            >
              <el-option key="all" :label="$t('GlobalSetObj.all')" :value="null" />
              <el-option
                v-for="item in LOST_TYPE"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!-- 订单类型 -->
          <el-form-item :label="$t('collectionCenter.tipoTitle')" size="small" style="width: 100%">
            <el-select
              v-model="queryForm.params.isReverse"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              style="width: 100%"
            >
              <el-option :label="$t('collectionCenter.tudo')" :value="null" /><!-- 全部 -->
              <el-option :label="$t('collectionCenter.originalOrder')" :value="0" /><!-- 原单 -->
              <el-option
                :label="$t('collectionCenter.originalOrderReturned')"
                :value="2"
              /><!-- 原单退回 -->
              <el-option
                :label="$t('collectionCenter.newOrderReturned')"
                :value="1"
              /><!-- 新单退回 -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-if="
            isArrayInclude(searchProp, [
              'createTime',
              'customerSendTime',
              'collectScanTime',
              'receiptTime',
              'sendTime',
              'deliverUploadScanTime',
              'dispatchReceiptTime',
              'lastDeliveryTime',
              'deliveredTime',
              'startDeliveryTime',
              'customerAgingEndTime'
            ])
          "
          :span="7"
        >
          <!--创建时间-->
          <el-form-item prop="searchTimeType" style="width: 100%">
            <template slot="label">
              <div class="selectLabel" style="width: 100%">
                <el-select
                  v-model="queryForm.params.timeType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                >
                  <!--订单创建时间-->
                  <el-option
                    v-if="searchProp.includes('createTime')"
                    key="1"
                    :label="$t('newOrder.orderCreateTime')"
                    :value="1"
                  />
                  <!--理应送达时间-->
                  <el-option
                    v-if="searchProp.includes('customerAgingEndTime')"
                    key="12"
                    :label="$t('orderCenterCont.dueTime01')"
                    :value="12"
                  />
                  <!--客户出仓时间-->
                  <el-option
                    v-if="searchProp.includes('customerSendTime')"
                    key="10"
                    :label="$t('orderCenterCont.customerDeliveryTime')"
                    :value="10"
                  />
                  <!--客户要求闭环时间-->
                  <el-option
                    v-if="searchProp.includes('expectedClosedTime')"
                    key="28"
                    :label="$t('orderCenterCont.customerRequiredCloseLoopTime')"
                    :value="28"
                  />
                  <!--末端揽收时间-->
                  <el-option
                    v-if="searchProp.includes('collectScanTime')"
                    key="2"
                    :label="$t('newOrder.lanshouT0')"
                    :value="2"
                  />
                  <!-- 揽收装车时间 -->
                  <el-option
                    v-if="searchProp.includes('collectLoadTime')"
                    key="25"
                    :label="$t('GlobalSetObj.collectuploadTime')"
                    :value="25"
                  />
                  <!-- 揽收封车时间 -->
                  <el-option
                    v-if="searchProp.includes('collectSealVehicleTime')"
                    key="17"
                    :label="$t('GlobalSetObj.collectSealVehicleTime')"
                    :value="17"
                  />
                  <!-- HUB1解封车时间 -->
                  <el-option
                    v-if="searchProp.includes('firstUnsealVehicleTime')"
                    key="18"
                    :label="$t('GlobalSetObj.firstUnsealVehicleTime')"
                    :value="18"
                  />
                  <!--              &lt;!&ndash; HUB1卸车时间 &ndash;&gt;-->
                  <!--              <el-option-->
                  <!--                v-if="searchProp.includes('firstUnloadVehicleTime')"-->
                  <!--                key="26"-->
                  <!--                :label="$t('changepwd.firstUnloadVehicleTime')"-->
                  <!--                :value="26"-->
                  <!--              />-->
                  <!--一级分拨到件时间-->
                  <el-option
                    v-if="searchProp.includes('receiptTime')"
                    key="3"
                    :label="$t('GlobalSetObj.oneTransitInboundTime')"
                    :value="3"
                  />
                  <!--一级分拨发件时间-->
                  <el-option
                    v-if="searchProp.includes('sendTime')"
                    key="4"
                    :label="$t('GlobalSetObj.oneshipmentTime')"
                    :value="4"
                  />
                  <!--              &lt;!&ndash; HUB1封车时间 &ndash;&gt;-->
                  <!--              <el-option-->
                  <!--                v-if="searchProp.includes('firstSealVehicleTime')" key="19"-->
                  <!--                :label="$t('GlobalSetObj.firstSealVehicleTime')" :value="19"-->
                  <!--              />-->
                  <!-- HUB2 解封车时间 -->
                  <el-option
                    v-if="searchProp.includes('secondUnsealVehicleTime')"
                    key="20"
                    :label="$t('GlobalSetObj.secondUnsealVehicleTime')"
                    :value="20"
                  />
                  <!--二级分拨到件时间-->
                  <el-option
                    v-if="searchProp.includes('transferInStorageTime')"
                    key="13"
                    :label="$t('GlobalSetObj.twoTransitInboundTime')"
                    :value="13"
                  />
                  <!--二级分拨发件时间-->
                  <el-option
                    v-if="searchProp.includes('transferOutStorageTime')"
                    key="14"
                    :label="$t('GlobalSetObj.twoshipmentTime')"
                    :value="14"
                  />
                  <!-- HUB2封车时间 -->
                  <el-option
                    v-if="searchProp.includes('secondSealVehicleTime')"
                    key="21"
                    :label="$t('GlobalSetObj.secondSealVehicleTime')"
                    :value="21"
                  />
                  <!-- HUB3解封车时间 -->
                  <el-option
                    v-if="searchProp.includes('thirdUnsealVehicleTime')"
                    key="22"
                    :label="$t('GlobalSetObj.thirdUnsealVehicleTime')"
                    :value="22"
                  />
                  <!--三级分拨到件时间-->
                  <el-option
                    v-if="searchProp.includes('thirdTransferInStorageTime')"
                    key="15"
                    :label="$t('GlobalSetObj.threeTransitInboundTime')"
                    :value="15"
                  />
                  <!--三级分拨发件时间-->
                  <el-option
                    v-if="searchProp.includes('thirdTransferOutStorageTime')"
                    key="16"
                    :label="$t('GlobalSetObj.threeshipmentTime')"
                    :value="16"
                  />
                  <!--HUB3封车时间-->
                  <el-option
                    v-if="searchProp.includes('thirdSealVehicleTime')"
                    key="23"
                    :label="$t('GlobalSetObj.thirdSealVehicleTime')"
                    :value="23"
                  />
                  <!--网点入库时间-->
                  <el-option
                    v-if="searchProp.includes('dispatchReceiptTime')"
                    key="5"
                    :label="$t('newOrder.StorageTimeOutlets')"
                    :value="5"
                  />
                  <!--网点派件时间-->
                  <el-option
                    v-if="searchProp.includes('lastDeliveryTime')"
                    key="9"
                    :label="$t('orderCenterCont.deliveryTime')"
                    :value="9"
                  />
                  <!--签收时间-->
                  <el-option
                    v-if="searchProp.includes('deliveredTime')"
                    key="6"
                    :label="$t('orderCenterCont.SigningTime')"
                    :value="6"
                  />
                  <!--问题件登记时间-->
                  <el-option
                    v-if="searchProp.includes('problemRecordTime')"
                    key="24"
                    :label="$t('orderCenterCont.problemTime')"
                    :value="24"
                  />
                  <!--最新轨迹时间-->
                  <el-option
                    v-if="searchProp.includes('lastTrackTime')"
                    key="27"
                    :label="$t('newOrder.LatestTime')"
                    :value="27"
                  />
                </el-select>
              </div>
            </template>
            <el-date-picker
              v-model="timeValue"
              :clearable="true"
              :default-time="['00:00:00', '23:59:59']"
              :format="$i18n.locale == 'zh' ? zhDate : ptDate"
              :picker-options="pickerOptions"
              :placeholder="$t('newOrder.SelectDatetime')"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleTime"
              @input="changeInput($event)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--  运单号 / 扫描单号   -->
          <el-form-item prop="inputValue" style="width: 100%">
            <el-select
              v-model="selectNumber"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              class="selectLabel"
              @change="changeNumber"
            >
              <el-option
                v-if="searchProp.includes('waybillNumber')"
                key="1"
                :label="$t('newOrder.waybillNumber')"
                :value="1"
              />
              <el-option
                v-if="searchProp.includes('scanOrderNumber')"
                key="2"
                :label="$t('GlobalSetObj.ScanNumber')"
                :value="2"
              />
              <el-option
                key="5"
                :label="$t('GlobalSetObj.anJunOrderNumber')"
                :value="5"
              /><!-- 安骏订单号 -->
              <el-option key="3" :label="$t('GlobalSetObj.PickUpBagNumber')" :value="3" />
              <el-option key="4" :label="$t('orderCenterCont.TransitBinBagNumber')" :value="4" />
            </el-select>
            <el-input
              v-if="selectNumber === 1"
              v-model="queryForm.params.inputValue"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="width: 100%"
              type="textarea"
            />
            <el-input
              v-if="selectNumber === 2"
              v-model="queryForm.params.scanOrderNumberList"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="width: 100%"
              type="textarea"
            />
            <el-input
              v-if="selectNumber === 3"
              v-model="queryForm.params.collectBagNumberList"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="width: 100%"
              type="textarea"
            />
            <el-input
              v-if="selectNumber === 4"
              v-model="queryForm.params.transitBagNumberList"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="width: 100%"
              type="textarea"
            />
            <el-input
              v-if="selectNumber === 5"
              v-model="queryForm.params.orderNumberList"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="width: 100%"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div style="margin-top: 10px">
        <el-form-item>
          <!--搜索-->
          <el-button
            icon="el-icon-search" size="small" type="primary"
            @click="enterSearch"
          >{{ $t('newOrder.search') }}
          </el-button>
          <!--重置-->
          <el-button
            icon="el-icon-refresh-left" size="small" type="info"
            @click="resetForm()"
          >{{ $t('newOrder.reset') }}
          </el-button>
          <el-button
            icon="el-icon-upload2"
            size="small"
            style="margin-bottom: 10px"
            @click="allExportOrder"
          >{{ $t('newOrder.export') }}
          </el-button>
          <!--批量单号导出-->
          <el-button
            size="small" type="primary" @click="clickBtchExport"
          >{{ $t('placeOrder.BatchExport') }}
          </el-button>
          <el-radio-group
            v-model="queryForm.params.customerType"
            size="small"
            style="margin-left: 10px"
            @change="enterSearch"
          >
            <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
            <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <!--自定义显示列-->
          <el-tooltip
            :content="$t('orderCenterCont.customizingDisplayColumns')"
            class="item"
            effect="dark"
            placement="top"
          >
            <el-button
              icon="el-icon-setting"
              style="font-size: 25px; color: #333; padding: 3px"
              type="text"
              @click="customColumn()"
            />
          </el-tooltip>
        </el-form-item>
      </div>
    </el-form>
    <div style="margin-top: -15px; margin-bottom: 10px; color: red">
      {{ $t('customerManagements.dataUpdateTime') }}: {{ lastSyncTime || '--' }}
    </div>
    </el-card>
    <el-card>
    <!--  表格数据  -->
    <el-table
      ref="timelinessWaybillTable" :data="tableData" border
      style="width: 100%"
    >
      <el-table-column
        v-for="(item, ind) in currentColumns"
        :key="ind"
        :label="item.label"
        :min-width="item.width"
        :prop="item.prop"
        :show-overflow-tooltip="!item.tips"
      >
        <template v-if="item.tips" slot="header">
          <div style="display: flex; align-items: center">
            <span style="margin-right: 2px">{{ item.label }}</span>
            <el-tooltip placement="top">
              <div slot="content">{{ item.tips }}</div>
              <span style="font-size: 12px; display: inline-flex; align-items: center">
                <svg-icon icon-class="QuestionMark" />
              </span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <div
            v-if="item.prop === 'waybillNumber'"
            style="color: #00A551; cursor: pointer"
            @click="toOrderDetail(scope.row)"
          >
            {{ scope.row.waybillNumber }}
          </div>
          <div v-else>
            {{ scope.row[item.prop] || '--' }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.number"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    </el-card>
    <!--详情-->
    <el-drawer
      :append-to-body="true"
      :visible.sync="waybillDescription"
      custom-class="drawerClass"
      direction="ltr"
      size="90%"
    >
      <div style="height: calc(100vh - 67px); overflow: auto">
        <detailPage :key="detailKey" :query-track-param="queryTrackParam" query-type="1" />
      </div>
    </el-drawer>
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('placeOrder.BatchExport')"
      :visible.sync="dialogVisibleExport"
      top="10vh"
      width="500px"
      @close="clearForm"
    >
      <el-form
        ref="exportRuleForm"
        :model="exportRuleForm"
        class="demo-exportRuleForm"
        label-position="top"
      >
        <el-form-item
          :rules="{
            required: true,
            message: $t('placeOrder.pleaseInput'),
            trigger: ['blur', 'change']
          }"
          prop="NumberType"
        >
          <el-select v-model="exportRuleForm.NumberType" style="width: 80%">
            <!--运单号-->
            <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" value="1" />
            <!--单号-->
            <el-option key="5" :label="$t('GlobalSetObj.ScanNumber')" value="5" />
          </el-select>
        </el-form-item>
        <el-form-item
          :rules="{
            required: true,
            message: $t('placeOrder.pleaseInput'),
            trigger: ['blur']
          }"
          prop="inputValeu"
          style="width: 100%"
        >
          <el-input
            v-model="exportRuleForm.inputValeu"
            :placeholder="$t('orderCenterCont.Multiple')"
            clearable
            rows="6"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin: 15px 0">
        <el-button
          size="small" @click="dialogVisibleExport = false"
        >{{ $t('GlobalSetObj.Cancelar') }}
        </el-button>
        <el-button
          size="small" type="primary" @click="comfireBtchExport"
        >{{ $t('collectionCenter.CheckItOutNow') }}
        </el-button>
      </div>
    </el-dialog>
    <!--自定义栏目-->
    <el-drawer
      :append-to-body="true"
      :title="$t('orderCenterCont.SelectColumn')"
      :visible.sync="showColumn"
      custom-class="drawerClass"
      direction="ltr"
      size="600px"
      @close="closeDrawer()"
    >
      <div class="columnTree" style="padding: 20px; height: calc(100vh - 140px); overflow: auto">
        <el-tree
          :key="dragging"
          ref="timelinessWaybillTree"
          :allow-drag="allowDrag"
          :allow-drop="allowDrop"
          :data="columnList"
          :default-checked-keys="checkedColumns"
          :props="props"
          check-on-click-node
          default-expand-all
          draggable
          node-key="prop"
          show-checkbox
          @check="handleCheckChange"
          @node-drop="handleDrop"
        >
          <span slot-scope="{ node, data }">
            <span v-if="data.tips">
              <span style="margin-right: 2px">{{ data.label }}</span>
              <el-tooltip placement="top">
                <div slot="content">{{ data.tips }}</div>
                <svg-icon icon-class="QuestionMark" />
              </el-tooltip>
            </span>
            <span v-else>{{ data.label }}</span>
          </span>
        </el-tree>
      </div>
      <div style="padding: 10px 20px; text-align: right; border-top: 1px solid #ccc">
        <el-button
          type="primary" @click="determineColumns()"
        >{{ $t('operationCenter.determine') }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { apiCustomerPage, apimerchantName, getLastSyncTime } from '@/api/customer';
import {
  getLgAreaListData,
  orderWaybillTimeRecord,
  orderWaybillTimeRecordExport,
  regionQueryList
} from '@/api/orderApi';
import detailPage from '@/components/detailComponent/detailPage.vue';
import { orderWaybillTimeRecordexportAll } from '@/api/logisticsOrders';
import dayjs from 'dayjs';
import { LOST_TYPE } from './utils';
import { cloneDeep } from 'lodash-es';
import { waybillStatusList, waybillStatusObj } from '@/utils/enumData';
import { siteFuzzyQuery } from '@/api/lanshou';
import { goResourceTaskList } from '@/utils/goExportList';

const PARAMS = {
  orderPackageType: null,
  orderNumberList: '',
  siteDataId: [],
  lostType: null, // 丢失类型
  inputValue: '',
  scanOrderNumberList: '',
  collectBagNumberList: '',
  transitBagNumberList: '',
  waybillStatus: [],
  customerIds: [],
  isTimeOut: -1,
  siteBusinessModel: null,
  timeType: 1,
  providerType: 1,
  customerType: 1, // 1：正式2：测试
  stateType: 0, // 0 收件人州, 1 实际入库州
  stateList: [],
  merchantCodeList: [],
  regionId: '', // 大区
  isReverse: null, // 订单类型
  queryFields: [], // 所展示的列
  senderStateList: []
};

export default {
  name: 'WaybillTimelinessStatistics',
  components: {
    detailPage
  },
  data() {
    return {
      selectNumber: 1,
      LOST_TYPE: '',
      // 详情
      waybillDescription: false,
      detailKey: new Date().getTime(),
      queryTrackParam: {},
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        number: 1,
        total: 0,
        params: cloneDeep(PARAMS)
      },
      siteData: [], // 网点
      tableData: [],
      // 勾选表格数据
      selectionList: [],
      searchNumberType: '1',
      searchNumber: '',
      customerList: [], // 客户列表
      isExport: false,
      exportType: 'CSV',
      exportParam: {},
      StateList: [], // 州
      selectDate: '',
      // 日期时间范围在一个月以内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      dialogVisibleExport: false,
      exportRuleForm: {
        NumberType: '1',
        inputValeu: ''
      },
      showColumn: false,
      dragging: new Date().getTime(),
      props: {
        label: 'label',
        children: 'children'
      },
      checkedColumns: [],
      checkedSelectColumns: [],
      currentColumns: [],
      searchProp: [],
      tableKey: new Date().getTime(),
      waybillStatusList: waybillStatusList,
      waybillStatusObject: waybillStatusObj,
      merchantList: [],
      regionList: [], // 大区列表
      lastSyncTime: ''
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '200px' : '140px'
      };
    },
    columnList() {
      return [
        {
          label: this.$i18n.t('basicData.all'), // '全部',
          prop: '',
          children: [
            // 运单号
            { prop: 'waybillNumber', label: '运单号（Número do Waybill）', width: 160 },
            // 扫描单号
            { prop: 'scanOrderNumber', label: '扫描单号（Código de barra）', width: 160 },
            // 安骏订单号
            { prop: 'orderNumber', label: '安骏订单号（Número do Pedido AnJun）', width: 160 },
            // 包裹类型
            { prop: 'orderPackageTypeDesc', label: '包裹类型（Tipo do pacote）', width: 160 },
            // 运单状态
            { prop: 'status', label: '运单状态（Status do Waybill）', width: 200 },
            // 最新状态时间
            {
              prop: 'lastTrackTime',
              label: '最新轨迹时间(Último data de rastreio)',
              width: 180
            },
            // 最新轨迹内容
            {
              prop: 'lastTrackContent',
              label: '最新轨迹内容（Último rastreio）',
              width: 180
            },
            // 最新轨迹网点
            {
              prop: 'lastTrackSiteName',
              label: '最新轨迹网点（Último ponto de rastreio）',
              width: 160
            },
            // 问题件原因
            { prop: 'deliveryFailedReason', label: '问题件原因（Motivo do problema）', width: 180 },
            // 丢失类型
            { prop: 'lostType', label: '标签（Tag）', width: 100 },
            // 订单类型
            { prop: 'orderType', label: '订单类型（Tipo do pedido）', width: 100 },
            // 收件人州
            { prop: 'receiveState', label: '收件人州（Estado do destinatário）', width: 160 },
            // 收件人城市
            { prop: 'receiveCity', label: '收件人城市（Cidade do destinatário）', width: 160 },
            // 收件人区
            { prop: 'receiveArea', label: '收件人区（Bairro do destinatário）', width: 160 },
            // 街道
            { prop: 'receiveStreet', label: '街道（Rua do destinatário）', width: 160 },
            // 收件人邮编
            { prop: 'receiveZipcode', label: '收件人邮编（CEP do destinatário）', width: 110 },
            // 区域
            { prop: 'region', label: '区域（Zona）', width: 160 },
            // 城镇类型
            { prop: 'cluster', label: '城镇类型（Tipo de cidade）', width: 160 },
            // 发件州
            { prop: 'senderState', label: '发件州（Estado de origem）', width: 160 },
            // 发件城市
            { prop: 'senderCity', label: '发件城市（Cidade de origem）', width: 160 },
            // 发件地区类型
            {
              prop: 'senderCluster',
              label: '发件地区类型（Hierarquia urbana de origem）',
              width: 160
            },
            // 客户名称
            { prop: 'customerName', label: '客户名称（Nome do cliente）', width: 170 },
            // 商户名称
            { prop: 'merchantName', label: '商户名称（Nome do Mercador）', width: 160 },
            // 大区 Região
            { prop: 'regionName', label: '大区（Região）', width: 100 },
            // 预派送网点
            {
              prop: 'preDeliverStationName',
              label: '预派送网点（Ponto previsto de entrega）',
              width: 160
            },
            // 实际入库网点
            {
              prop: 'warehouseStationName',
              label: '实际入库网点（Ponto de entrada）',
              width: 160
            },
            // 实际入库网点州
            {
              prop: 'warehouseState',
              label: '实际入库网点州（Estado do ponto de entrada）',
              width: 190
            },
            // 实际派送网点
            {
              prop: 'deliverStationName',
              label: '实际派送网点（Ponto de entrega）',
              width: 160
            },
            // 派送员
            { prop: 'delivererName', label: '派送员（Entregador）', width: 160 },
            // 揽收类型
            { prop: 'collectTypeName', label: '揽收类型（Tipo de coleta）', width: 160 },
            // 签收类型
            { prop: 'signTypeName', label: '签收类型（Tipo de assinatura）', width: 160 },
            // 签收人类型
            { prop: 'signTypeStr', label: '签收人类型（Tipo do destinatário）', width: 160 },
            // 签收人关系
            {
              prop: 'notMyselfTypeStr',
              label: '签收人关系（Relação do Destinatário）',
              width: 160
            },
            // 订单创建时间
            { prop: 'createTime', label: '订单创建时间（Criação de pedido）', width: 160 },
            // 客户出仓时间
            {
              prop: 'customerSendTime',
              label: '客户出仓时间（Tempo de saída da encomenda）',
              width: 160
            },
            // 末端揽收时间
            { prop: 'collectScanTime', label: '末端揽收时间（Coleta de LM）', width: 180 },
            // 揽收装车时间
            {
              prop: 'collectLoadTime',
              label: '揽收装车时间（Carregamento da coleta）',
              width: 180
            },
            // 揽收下一站
            { prop: 'collectLoadNextStation', label: '揽收下一站（Próxima ponto da coleta）', width: 180 },
            // 揽收时长(H)
            {
              prop: 'collectCreateDuration',
              label: '揽收时长(H)（Duração da coleta(H)）',
              width: 180,
              tips: '揽收时间减去客户出仓时间（Horário da coleta menos o horário de saída do armazém do cliente）'
            },
            // 揽收运输时长(H)
            {
              prop: 'collectTransportDuration',
              label: '揽收运输时长(H)（Duração do transporte de coleta(H)）',
              width: 180,
              tips: '揽收装车下一站的解封车/到件/卸车时间减去揽收装车时间（Tempo de abertura/chegada/descarga do próximo ponto menos tempo de carregamento da coleta）'
            },
            // 揽收封车时间
            {
              prop: 'collectSealVehicleTime',
              label: '揽收封车时间（Fechamento do veículo da coleta）',
              width: 180
            },
            // HUB1解封车时间
            {
              prop: 'firstUnsealVehicleTime',
              label: 'HUB1解封车时间（Abertura do veículo do HUB1）',
              width: 180
            },
            // 一级分拨到件时间
            {
              prop: 'receiptTime',
              label: '一级分拨到件时间（Entrada no centro nível 01）',
              width: 180
            },
            // 实际到件分拨中心(一级)
            {
              prop: 'firstTransferSiteName',
              label: '实际到件分拨中心（Centro real de chegada）',
              width: 180
            },
            // 一级分拨发件时间
            {
              prop: 'sendTime',
              label: '一级分拨发件时间（Saída do centro nível 01）',
              width: 180
            },
            // 下一站
            { prop: 'firstTransferNextStation', label: '下一站（Próxima ponto）', width: 180 },
            // HUB1封车时间
            {
              prop: 'firstSealVehicleTime',
              label: 'HUB1封车时间（Fechamento do veículo do HUB1）',
              width: 180
            },
            // 一级分拨操作时长
            {
              prop: 'receiptSendDuration',
              label: '一级分拨操作时长(H)（Duração da operação do centro nível 01(H)）',
              width: 180,
              tips: '一级分拨装车时间减去一级分拨到件/卸车/解封车时间（Tempo de carregamento do centro nível 01 menos tempo de chegada/descarga/abertura）'
            },
            // HUB2解封车时间
            {
              prop: 'secondUnsealVehicleTime',
              label: 'HUB2解封车时间（Abertura do veículo do HUB2）',
              width: 180
            },
            // 二级分拨到件时间
            {
              prop: 'transferInStorageTime',
              label: '二级分拨到件时间（Entrada no centro nível 02）',
              width: 180
            },
            // 实际到件分拨中心(二级)
            {
              prop: 'transferSiteName',
              label: '实际到件分拨中心（Centro real de chegada）',
              width: 180
            },
            // 二级分拨发件时间
            {
              prop: 'transferOutStorageTime',
              label: '二级分拨发件时间（Saída do centro nível 02）',
              width: 180
            },
            // 下一站
            { prop: 'secondTransferNextStation', label: '下一站（Próxima ponto）', width: 180 },
            // HUB2封车时间
            {
              prop: 'secondSealVehicleTime',
              label: 'HUB2封车时间（Fechamento do veículo do HUB2）',
              width: 180
            },
            // 二级分拨操作时长
            {
              prop: 'transferInOutStorageDuration',
              label: '二级分拨操作时长(H)（Duração da operação do centro nível 02(H)）',
              width: 180,
              tips: '二级分拨装车时间减去二级分拨到件/卸车/解封车时间（Tempo de carregamento do centro nível 02 menos tempo de chegada/descarga/abertura）'
            },
            // HUB3解封车时间
            {
              prop: 'thirdUnsealVehicleTime',
              label: 'HUB3解封车时间（Abertura do veículo do HUB3）',
              width: 180
            },
            // 三级分拨到件时间
            {
              prop: 'thirdTransferInStorageTime',
              label: '三级分拨到件时间（Entrada no centro nível 03）',
              width: 180
            },
            // 实际到件分拨中心(三级)
            {
              prop: 'thirdTransferSite',
              label: '实际到件分拨中心（Centro real de chegada）',
              width: 180
            },
            // 三级分拨发件时间
            {
              prop: 'thirdTransferOutStorageTime',
              label: '三级分拨发件时间（Saída do centro nível 03）',
              width: 180
            },
            // 下一站
            { prop: 'thirdTransferNextStation', label: '下一站（Próxima ponto）', width: 180 },
            // HUB3封车时间
            {
              prop: 'thirdSealVehicleTime',
              label: 'HUB3封车时间（Tempo de bloqueio do HUB3）',
              width: 180
            },
            // 三级分拨操作时长
            {
              prop: 'thirdTransferDuration',
              label: '三级分拨操作时长(H)（Duração da operação do centro de distribuição nível 03(H)）',
              width: 180,
              tips: '三级分拨装车时间减去三级分拨到件/卸车/解封车时间（Tempo de carregamento do centro nível 03 menos tempo de chegada/descarga/abertura）'
            },
            // 网点解封车时间
            {
              prop: 'unsealVehicleTime',
              label: '网点解封车时间（Tempo de desbloqueio do ponto）',
              width: 180
            },
            // 网点入库时间
            {
              prop: 'dispatchReceiptTime',
              label: '网点入库时间（Tempo de inbound no ponto）',
              width: 180
            },
            // 网点派件时间
            {
              prop: 'lastDeliveryTime',
              label: '网点派件时间（Horário de Entrega do Ponto）',
              width: 180
            },
            // 第一次派送时间
            {
              prop: 'firstDeliveryTime',
              label: '第一次派送时间（Horário da Primeira Entrega）',
              width: 180,
              tips: '第一次派送任务分配的时间（Horário da Primeira Atribuição de Tarefa de Entrega）',
              index: 63
            },
            // 第二次派送时间
            {
              prop: 'secondDeliveryTime',
              label: '第二次派送时间（Horário da Segunda Entrega）',
              width: 180,
              tips: '第二次派送任务的分配时间（Horário da Segunda Atribuição de Tarefa de Entrega）',
              index: 64
            },
            // 第三次派送时间
            {
              prop: 'threeDeliveryTime',
              label: '第三次派送时间（Horário da Terceira Entrega）',
              width: 180,
              tips: '第三次派送任务的分配时间（Horário da Terceira Atribuição de Tarefa de Entrega）'
            },
            // 首派时间
            {
              prop: 'startDeliveryTime',
              label: '首派时间（Tempo de entrega primeira）',
              width: 180,
              tips: '在网点入库后登记的第一次问题件或签收时间（Tempo do primeiro registro de problema ou assinatura após inbound no ponto）'
            },
            // 签收时间
            { prop: 'deliveredTime', label: '签收时间（Hora da assinatura）', width: 180 },
            // 网点派件时长(H)
            {
              prop: 'siteDispatchDuration',
              label: '网点派件时长(H)（Duração de entrega do ponto(H)）',
              width: 180,
              tips: '网点派件时间减去网点入库时间（Tempo de entrega do ponto menos o tempo de inbound no ponto）'
            },
            // 派件在途时长(H)
            {
              prop: 'dispatchTransitDuration',
              label: '派件在途时长(H)（Duração de trânsito de entrega(H)）',
              width: 180,
              tips: '签收时间减去网点派送时间（Tempo da assinatura menos o tempo de entrega do ponto）'
            },
            // 首派所用时长(H)
            {
              prop: 'startDeliveryDuration',
              label: '首派所用时长(H)（Prazo usado de entrega primeira(H)）',
              width: 180,
              tips: '首派时间减去客户出仓时间（Tempo de primeira entrega menos tempo de saída do cliente）'
            },
            // 网点签收时长(H)
            {
              prop: 'deliverDispatchReceiptDuration',
              label: '网点签收时长(H)（Duração de assinatura do ponto(H)）',
              width: 180,
              tips: '签收时间减去网点入库时间（Tempo da assinatura menos o de inbound no ponto）'
            },
            // 总签收时长(H)
            {
              prop: 'totalSignDuration',
              label: '总签收时长(H)（Duração total de assinatura(H)）',
              width: 180,
              tips: '签收时长减去末端揽收时间（Tempo da assinatura menos o tempo de coleta de LM）'
            },
            // HUB1发出运输时长(H)
            {
              prop: 'firstTransportDuration',
              label: 'HUB1发出运输时长(H)（Duração de transporte HUB1(H)）',
              width: 180,
              tips: '下一站的解封车/到件/卸车时间减去一级装车时间（Tempo de abertura/chegada/descarga do próximo ponto menos tempo de carregamento do nível 01）'
            },
            // HUB2发出运输时长(H)
            {
              prop: 'secondTransportDuration',
              label: 'HUB2发出运输时长(H)（Duração de transporte HUB2(H)）',
              width: 180,
              tips: '下一站的到件/卸车时间减去二级装车时间（Tempo de chegada/descarga do próximo ponto menos tempo de carregamento do nível 02）'
            },
            // HUB3发出运输时长(H)
            {
              prop: 'thirdTransportDuration',
              label: 'HUB3发出运输时长(H)（Duração de transporte HUB3(H)）',
              width: 180,
              tips: '下一站的到件/卸车时间减去三级装车时间（Tempo de chegada/descarga do próximo ponto menos tempo de carregamento do nível 03）'
            },
            // 客户时效要求天数
            {
              prop: 'customerAging',
              label: '客户时效要求天数（Dias de prazo requisitados por cliente）',
              width: 180
            },
            // 理应送达时间
            {
              prop: 'customerAgingEndTime',
              label: '理应送达时间（Horário em que deve ser entregue）',
              width: 180
            },
            // 超时时长
            {
              prop: 'timeOutDuration',
              label: '超时时长（Tempo Excedido）',
              width: 180,
              tips: '当前时间减去SHEIN时效到期时间（Tempo atual menos o horário limite de entrega da SHEIN.）'
            },
            // 超时天数
            {
              prop: 'dayOutDuration',
              label: '超时天数（Dias de atraso）',
              width: 180,
              tips: '超时时长对应的天数（Número de dias correspondentes à duração do atraso）'
            },
            // 客户要求闭环天数
            {
              prop: 'customerAgingClosed',
              label: '客户要求闭环天数（Número de dias de ciclo fechado solicitado pelo cliente）',
              width: 160
            },
            // 客户要求闭环时间
            {
              prop: 'expectedClosedTime',
              label: '客户要求闭环时间（O cliente exige um tempo de fechamento）',
              width: 160
            },
            // 问题件登记时间
            {
              prop: 'problemRecordTime',
              label: '问题件登记时间（Horário de registro de problema）',
              width: 180
            },
            // 问题件登记网点
            {
              prop: 'problemRecordSite',
              label: '问题件登记网点（Ponto de registro de problema）',
              width: 180
            },
            {
              prop: 'siteFirstReturnTime',
              label: '网点首次退件时间（Data da Primeira Devolução do Ponto）',
              width: 180,
              tips: '第一次服务商系统操作「退仓发件」产生的轨迹时间（Horário de rastreamento gerado pela primeira operação "Envio de Devolução ao Armazém" no sistema do prestador de serviços）'
            }
          ]
        }
      ];
    }
  },
  watch: {
    currentColumns(newVal) {
      this.queryForm.params.queryFields = newVal.map((item) => item.prop);
    }
  },
  created() {
    this.LOST_TYPE = LOST_TYPE;

    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getAddress();
    this.getSupperSite('');
    this.getHeaderColumn();
    this.getSearch(1);
    // 获取大区列表
    this.getRegionList();
    this.selectNumber = this.searchProp.includes('waybillNumber')
      ? 1
      : this.searchProp.includes('scanOrderNumber')
        ? 2
        : 3;
  },
  methods: {
    changeNumber() {
      this.queryForm.params.inputValue = '';
      this.queryForm.params.scanOrderNumberList = '';
      this.queryForm.params.collectBagNumberList = '';
      this.queryForm.params.transitBagNumberList = '';
      this.queryForm.params.orderNumberList = '';
    },
    // 获取商户列表
    getMerchantList(val = '', flag) {
      const data = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantName: ''
        }
      };
      if (flag) {
        if (this.merchantList.length === 0) {
          apimerchantName(data).then((res) => {
            if (res.code === 200) {
              this.merchantList = res.data.records;
            }
          });
        }
      } else {
        data.params.merchantName = val;
        apimerchantName(data).then((res) => {
          if (res.code === 200) {
            this.merchantList = res.data.records;
          }
        });
      }
    },
    // 判断一个数组中是否包含另一个数组中的元素
    isArrayInclude(arr1, arr2) {
      return arr2.some((element) => arr1.includes(element));
    },
    // 找出两个数组中相同的元素
    findCommonElements(arr1, arr2) {
      return arr1.filter((element) => arr2.includes(element));
    },
    // 找出两个数组中不相同的元素
    findDifferentElements(arr1, arr2) {
      // 找出arr1中不存在于arr2的元素
      const uniqueToArr1 = arr1.filter((element) => !arr2.includes(element));
      // 找出arr2中不存在于arr1的元素
      const uniqueToArr2 = arr2.filter((element) => !arr1.includes(element));
      // 将两个数组中的不同元素合并
      return [...uniqueToArr1, ...uniqueToArr2];
    },
    // 设置搜索类型默认值
    setDefaultData() {
      // 设置网点搜索类型默认值
      if (this.searchProp.includes('preDeliverStationName')) {
        // 如果列表展示了预派送网点，搜索类型值默认为预派送网点 1
        this.queryForm.params.providerType = 1;
      } else if (this.searchProp.includes('deliverStationName')) {
        // 如果列表没有展示预派送网点，展示了实际派送网点，搜索类型值默认为实际派送网点 2
        this.queryForm.params.providerType = 2;
      } else if (this.searchProp.includes('warehouseStationName')) {
        // 如果列表没有展示预派送网点和实际派送网点，只展示了实际入库网点，搜索类型值默认为实际入库网点 3
        this.queryForm.params.providerType = 3;
      } else if (this.searchProp.includes('latestTrackingBranch')) {
        // 如果列表没有展示预派送网点和实际派送网点，只展示了实际入库网点，搜索类型值默认为实际入库网点 3
        this.queryForm.params.providerType = 4;
      } else {
        // 如果列表没有展示预派送网点和实际派送网点也没有实际入库网点，，搜索类型值默认为null
        this.queryForm.params.providerType = 1;
      }
      // 设置搜索州类型默认值
      if (this.searchProp.includes('receiveState')) {
        // 如果列表展示了收件人州，搜索类型值默认为收件人州 0
        this.queryForm.params.stateType = 0;
      } else if (this.searchProp.includes('warehouseState')) {
        // 否则默认为实际入库网点州 1
        this.queryForm.params.stateType = 1;
      } else {
        this.queryForm.params.stateType = 0;
      }
      // 设置搜索时间类型默认值
      if (this.searchProp.includes('createTime')) {
        // 如果列表展示了订单创建时间，搜索类型值默认为订单创建时间 1
        this.queryForm.params.timeType = 1;
      } else if (this.searchProp.includes('collectScanTime')) {
        // 默认为揽收时间 2
        this.queryForm.params.timeType = 2;
      } else if (this.searchProp.includes('receiptTime')) {
        // 一级分拨到件时间
        this.queryForm.params.timeType = 3;
      } else if (this.searchProp.includes('sendTime')) {
        // 一级分拨发件时间
        this.queryForm.params.timeType = 4;
      } else if (this.searchProp.includes('transferInStorageTime')) {
        // 二级分拨到件时间
        this.queryForm.params.timeType = 13;
      } else if (this.searchProp.includes('transferOutStorageTime')) {
        // 二级分拨发件时间
        this.queryForm.params.timeType = 14;
      } else if (this.searchProp.includes('dispatchReceiptTime')) {
        // 网点入库时间
        this.queryForm.params.timeType = 5;
      } else if (this.searchProp.includes('startDeliveryTime')) {
        // 首派时间
        this.queryForm.params.timeType = 8;
      } else if (this.searchProp.includes('lastDeliveryTime')) {
        // 网点派件时间
        this.queryForm.params.timeType = 9;
      } else if (this.searchProp.includes('deliveredTime')) {
        // 签收时间
        this.queryForm.params.timeType = 6;
      } else if (this.searchProp.includes('customerSendTime')) {
        // 客户出仓时间
        this.queryForm.params.timeType = 10;
      } else if (this.searchProp.includes('customerAgingEndTime')) {
        // 理应送达时间
        this.queryForm.params.timeType = 12;
      } else {
        this.queryForm.params.timeType = 1;
      }
    },
    // 获取当前用户自定义列表表头
    getHeaderColumn() {
      // 获取浏览器缓存
      const columnList = localStorage.getItem('timelinessWaybillColumnList');
      let selectedColumn = [];
      if (columnList) {
        selectedColumn = JSON.parse(columnList);
      } else {
        selectedColumn = [];
      }
      this.currentColumns = [];
      this.searchProp = [];
      const selectedProp = [];
      const allProp = [];
      console.log(selectedColumn, '===selectedColumn');
      // 获取已选中的栏目标识
      selectedColumn.map((list) => {
        if (selectedProp.includes(list.prop) === false) {
          selectedProp.push(list.prop);
        }
      });
      console.log(this.columnList[0].children, '==this.columnList[0].children');
      // 获取全部标识
      this.columnList[0].children.map((item) => {
        if (allProp.includes(item.prop) === false) {
          allProp.push(item.prop);
        }
      });
      const commonElements = this.findCommonElements(selectedProp, allProp);
      if (commonElements.length > 0) {
        commonElements.map((list) => {
          this.columnList[0].children.map((item) => {
            if (list === item.prop) {
              this.currentColumns.push(item);
              this.searchProp.push(item.prop);
            }
          });
        });
      } else {
        this.columnList[0].children.map((item) => {
          if (selectedProp.includes(item.prop) === false) {
            selectedProp.push(item.prop);
          }
          this.currentColumns.push(item);
          this.searchProp.push(item.prop);
        });
      }
      // allColumn = cloneDeep(this.currentColumns);
      // const differentElements = this.findDifferentElements(allProp, selectedProp);
      let allNodes = JSON.parse(localStorage.getItem('timelinessWaybillAllNodes'));
      if (!allNodes) {
        allNodes = cloneDeep(allProp);
      }
      // 排序
      const orderMap = new Map(allNodes.map((prop, index) => [prop, index]));
      this.columnList[0].children.sort((a, b) => {
        return orderMap.get(a.prop) - orderMap.get(b.prop);
      });
      // 页面加载的时候设置table的高度
      this.$nextTick(() => {
        this.setDefaultData();
        this.columnList[0].children = cloneDeep(this.columnList[0].children);
        this.tableKey = new Date().getTime();
      });
    },
    // 打开自定义栏目弹窗
    customColumn() {
      const selectedColumn = cloneDeep(this.currentColumns);
      this.checkedColumns = [];
      this.searchProp = [];
      let allNodes = JSON.parse(localStorage.getItem('timelinessWaybillAllNodes'));
      if (!allNodes) {
        allNodes = this.columnList[0].children.map((item) => {
          return item.prop;
        });
      }
      // 排序
      const orderMap = new Map(allNodes.map((prop, index) => [prop, index]));
      this.columnList[0].children.sort((a, b) => {
        return orderMap.get(a.prop) - orderMap.get(b.prop);
      });
      this.checkedSelectColumns = cloneDeep(this.columnList[0].children);
      this.checkedSelectColumns.map((item) => {
        if (selectedColumn.length > 0) {
          selectedColumn.map((list) => {
            if (item.prop === list.prop) {
              this.checkedColumns.push(item.prop);
              this.searchProp.push(item.prop);
            }
          });
        } else {
          this.checkedColumns.push(item.prop);
          this.searchProp.push(item.prop);
        }
      });
      this.showColumn = true;
      this.dragging = new Date().getTime();
    },
    // 确定保存已选栏目
    determineColumns() {
      const columns = [];
      const neKey = this.$refs.timelinessWaybillTree.getCheckedKeys();
      if (neKey.length > 0) {
        this.columnList[0].children.map((list) => {
          if (neKey.includes(list.prop)) {
            columns.push(list);
          }
        });
      }
      if (columns.length === 0) {
        this.$message.warning(this.$t('receivablePayable.SelectAtLeastOnePieceOfData'));
        return;
      }
      const allNodes = this.getAllTreeNodes(this.columnList[0].children);
      localStorage.setItem('timelinessWaybillAllNodes', JSON.stringify(allNodes));
      localStorage.setItem('timelinessWaybillColumnList', JSON.stringify(columns));
      this.getHeaderColumn();
      this.showColumn = false;
      this.$nextTick(() => {
        this.queryForm.number = 1;
        this.getTimer();
        this.queryForm.params = cloneDeep(PARAMS);
        this.setDefaultData();
        this.$refs.timelinessWaybillTable.doLayout();
      });
    },
    // 获取栏目树上所有节点的值
    getAllTreeNodes(nodes) {
      let result = [];
      nodes.forEach((node) => {
        result.push(node.prop);
        if (node.children && node.children.length > 0) {
          result = result.concat(this.getAllTreeNodes(node.children));
        }
      });
      return result;
    },
    // 关闭自定义栏目弹窗事件将未保存的数据还原
    closeDrawer() {
      this.columnList[0].children = this.checkedSelectColumns;
      this.selectNumber = this.searchProp.includes('waybillNumber')
        ? 1
        : this.searchProp.includes('scanOrderNumber')
          ? 2
          : 3;
    },
    // 判断节点是否能被拖拽
    allowDrag(node) {
      return node.level === 2;
    },
    // 判断节点是否可放置
    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.level === 2 && type !== 'inner') {
        return true;
      } else {
        return false;
      }
    },
    // 拖拽成功后触发事件
    handleDrop(draggedNode, insertNode, dropLocation, event) {
      this.dragging = new Date().getTime();
    },
    // 栏目勾选
    handleCheckChange(code, node) {
      this.checkedColumns = node.checkedKeys;
    },
    enterSearch() {
      this.queryForm.number = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.number = 1;
      this.getTimer();
      this.queryForm.params = cloneDeep(PARAMS);
      this.setDefaultData();
      this.getSearch();
      this.getMerchantList('');
      this.getCustomerPage('');
      this.selectNumber =
        this.searchProp.includes('waybillNumber') ||
        (this.searchProp.includes('waybillNumber') && this.searchProp.includes('scanOrderNumber'))
          ? 1
          : this.searchProp.includes('scanOrderNumber')
            ? 2
            : 3;
    },
    // 批量导出
    clickBtchExport() {
      this.dialogVisibleExport = true;
    },
    // 确定批量导出
    comfireBtchExport() {
      this.$refs['exportRuleForm'].validate((valid) => {
        if (valid) {
          const numList = this.exportRuleForm.inputValeu
            ? this.exportRuleForm.inputValeu.split('\n')
            : [];
          const filteredArray = numList.filter((item) => /\S/.test(item));
          if (filteredArray.length === 0) {
            this.$message.error(this.$t('GlobalSetObj.notMore10wTip'));
            return;
          }
          if (filteredArray.length > 100000) {
            this.$message.error(this.$t('GlobalSetObj.notMore10w'));
            return;
          }
          const data = {};
          if (this.exportRuleForm.NumberType === '1') {
            data.waybillNumberList = filteredArray;
            data.scanOrderNumberList = [];
          } else {
            data.waybillNumberList = [];
            data.scanOrderNumberList = filteredArray;
          }
          data.queryFields = this.currentColumns.map((item) => item.prop);
          orderWaybillTimeRecordexportAll(data).then((res) => {
            if (res.code === 200) {
              this.dialogVisibleExport = false;
              goResourceTaskList();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 导出
    allExportOrder() {
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      if (this.queryForm.params.scanOrderNumberList) {
        inputValList = this.queryForm.params.scanOrderNumberList
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      if (this.queryForm.params.collectBagNumberList) {
        inputValList = this.queryForm.params.collectBagNumberList
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      if (this.queryForm.params.transitBagNumberList) {
        inputValList = this.queryForm.params.transitBagNumberList
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      if (this.queryForm.params.orderNumberList) {
        inputValList = this.queryForm.params.orderNumberList
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      // return;
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.number;
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.startTime = this.timeValue[0];
        data.params.endTime = this.timeValue[1];
      } else {
        data.params.startTime = '';
        data.params.endTime = '';
      }
      data.params.waybillNumberList = this.selectNumber === 1 ? inputValList : [];
      data.params.scanOrderNumberList = this.selectNumber === 2 ? inputValList : [];
      data.params.collectBagNumberList = this.selectNumber === 3 ? inputValList : [];
      data.params.transitBagNumberList = this.selectNumber === 4 ? inputValList : [];
      data.params.orderNumberList = this.selectNumber === 5 ? inputValList : [];
      data.params.timeType = this.queryForm.params.timeType;
      data.params.providerType = this.queryForm.params.providerType;
      data.params.customerIds = this.queryForm.params.customerIds;
      data.params.merchantCodeList = this.queryForm.params.merchantCodeList;
      data.params.isTimeOut = this.queryForm.params.isTimeOut;
      data.params.siteBusinessModel = this.queryForm.params.siteBusinessModel;
      data.params.isReverse = this.queryForm.params.isReverse;
      data.params.queryFields = this.currentColumns.map((item) => item.prop);
      // 订单类型
      if (data.params.isReverse === 2) {
        data.params.isOriginalReturn = 1;
        data.params.isReverse = '';
      } else if (data.params.isReverse === 0) {
        data.params.isOriginalReturn = 0;
      } else {
        data.params.isOriginalReturn = null;
      }
      let statusList = [];
      if (this.queryForm.params.waybillStatus.includes(3)) {
        statusList = cloneDeep(this.queryForm.params.waybillStatus);
        if (!statusList.includes(19)) {
          statusList.push(19);
        }
      } else {
        statusList = this.queryForm.params.waybillStatus;
      }
      data.params.waybillStatus = statusList;
      data.params.stateType = this.queryForm.params.stateType;
      data.params.stateList = this.queryForm.params.stateList;
      data.params.lostType = this.queryForm.params.lostType;
      data.params.senderStateList = this.queryForm.params.senderStateList;
      data.params.orderPackageType = this.queryForm.params.orderPackageType;
      data.params.deliverStationIdList = [];
      if (this.queryForm.params.regionId && this.queryForm.params.regionId?.length) {
        const obj = this.queryForm.params.regionId.reduce(
          (accumulator, currentItem) => {
            if (!Array.isArray(currentItem)) {
              return accumulator;
            }
            if (currentItem.length === 1) {
              accumulator.singles.push(currentItem[0]);
            } else if (currentItem.length === 2) {
              accumulator.doubles.push(currentItem[1]);
            }
            return accumulator;
          },
          // reduce 的初始值，定义了我们最终想要的结构
          { singles: [], doubles: [] }
        );
        if (obj?.doubles && obj?.doubles?.length) {
          data.params.deliverStationIdList = obj.doubles;
        }
        if (obj?.singles && obj?.singles?.length) {
          data.params.regionIds = obj?.singles;
        }
      }
      // 获取大区选中和网点选中
      if (this.queryForm.params.regionId) {
        if (this.queryForm.params.regionId?.level1) {
          data.params.regionId = this.queryForm.params.regionId?.level1[0].groupValue;
        }
        if (
          this.queryForm.params.regionId?.level2 &&
          this.queryForm.params.regionId?.level2.length
        ) {
          data.params.deliverStationIdList = this.queryForm.params.regionId?.level2.map((item) => {
            return item.value;
          });
        }
      }
      data.params.customerType = this.queryForm.params.customerType;
      if (this.queryForm.params.siteDataId?.length > 0) {
        data.params.deliverStationIdList = this.queryForm.params.siteDataId;
      }
      if (
        !this.queryForm.params.inputValue &&
        !this.queryForm.params.scanOrderNumberList &&
        !this.queryForm.params.collectBagNumberList &&
        !this.queryForm.params.transitBagNumberList &&
        !this.queryForm.params.orderNumberList
      ) {
        if (!data.params.startTime && !data.params.endTime) {
          this.$message.warning(this.$t('newOrder.timeIsNotNull'));
          return;
        }
      }
      this.exportParam = data;
      const param = {
        ...this.exportParam.params,
        exportType: 'CSV'
      };
      if (param.waybillNumberList.length === 0) {
        if (this.timeValue && this.timeValue.length === 0) {
          this.$message.warning(this.$t('newOrder.timeIsNotNull'));
          return;
        }
      }
      orderWaybillTimeRecordExport(param).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 查询
    getSearch(val) {
      this.queryForm.params.queryFields = this.currentColumns.map((item) => item.prop);
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      if (this.queryForm.params.scanOrderNumberList) {
        inputValList = this.queryForm.params.scanOrderNumberList
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      if (this.queryForm.params.collectBagNumberList) {
        inputValList = this.queryForm.params.collectBagNumberList
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      if (this.queryForm.params.transitBagNumberList) {
        inputValList = this.queryForm.params.transitBagNumberList
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      if (this.queryForm.params.orderNumberList) {
        inputValList = this.queryForm.params.orderNumberList
          .split('\n')
          .filter((item) => item && item.trim())
          .map((items) => items.replace(/\s/g, '').trim());
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      // return;
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.number;
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.startTime = this.timeValue[0];
        data.params.endTime = this.timeValue[1];
      } else {
        data.params.startTime = '';
        data.params.endTime = '';
      }
      data.params.waybillNumberList = this.selectNumber === 1 ? inputValList : [];
      data.params.scanOrderNumberList = this.selectNumber === 2 ? inputValList : [];
      data.params.collectBagNumberList = this.selectNumber === 3 ? inputValList : [];
      data.params.transitBagNumberList = this.selectNumber === 4 ? inputValList : [];
      data.params.orderNumberList = this.selectNumber === 5 ? inputValList : [];
      data.params.timeType = this.queryForm.params.timeType;
      data.params.siteBusinessModel = this.queryForm.params.siteBusinessModel;
      data.params.providerType = this.queryForm.params.providerType;
      data.params.customerIds = this.queryForm.params.customerIds;
      data.params.merchantCodeList = this.queryForm.params.merchantCodeList;
      data.params.isTimeOut = this.queryForm.params.isTimeOut;
      data.params.isReverse = this.queryForm.params.isReverse;
      data.params.queryFields = this.queryForm.params.queryFields;
      // 订单类型
      if (data.params.isReverse === 2) {
        data.params.isOriginalReturn = 1;
        data.params.isReverse = '';
      } else if (data.params.isReverse === 0) {
        data.params.isOriginalReturn = 0;
      } else {
        data.params.isOriginalReturn = null;
      }
      // data.params.waybillStatus = this.queryForm.params.waybillStatus;
      let statusList = [];
      if (this.queryForm.params.waybillStatus.includes(3)) {
        statusList = cloneDeep(this.queryForm.params.waybillStatus);
        if (!statusList.includes(19)) {
          statusList.push(19);
        }
      } else {
        statusList = this.queryForm.params.waybillStatus;
      }
      data.params.waybillStatus = statusList;
      data.params.stateType = this.queryForm.params.stateType;
      data.params.stateList = this.queryForm.params.stateList;
      data.params.lostType = this.queryForm.params.lostType;
      data.params.senderStateList = this.queryForm.params.senderStateList;
      data.params.orderPackageType = this.queryForm.params.orderPackageType;
      // data.params.providerIdList = [];
      data.params.deliverStationIdList = [];
      if (this.queryForm.params.regionId && this.queryForm.params.regionId?.length) {
        const obj = this.queryForm.params.regionId.reduce(
          (accumulator, currentItem) => {
            if (!Array.isArray(currentItem)) {
              return accumulator;
            }
            if (currentItem.length === 1) {
              accumulator.singles.push(currentItem[0]);
            } else if (currentItem.length === 2) {
              accumulator.doubles.push(currentItem[1]);
            }
            return accumulator;
          },
          // reduce 的初始值，定义了我们最终想要的结构
          { singles: [], doubles: [] }
        );
        if (obj?.doubles && obj?.doubles?.length) {
          data.params.deliverStationIdList = obj.doubles;
        }
        if (obj?.singles && obj?.singles?.length) {
          data.params.regionIds = obj?.singles;
        }
      }
      data.params.customerType = this.queryForm.params.customerType;
      if (this.queryForm.params.siteDataId?.length > 0) {
        data.params.deliverStationIdList = this.queryForm.params.siteDataId;
      }
      if (
        !this.queryForm.params.inputValue &&
        !this.queryForm.params.scanOrderNumberList &&
        !this.queryForm.params.collectBagNumberList &&
        !this.queryForm.params.transitBagNumberList &&
        !this.queryForm.params.orderNumberList
      ) {
        if (!data.params.startTime && !data.params.endTime) {
          this.$message.warning(this.$t('newOrder.timeIsNotNull'));
          return;
        }
      }
      this.getLastSyncTimeData();
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      orderWaybillTimeRecord(data)
        .then((res) => {
          if (res.code === 200) {
            this.queryForm.total = res.data.total;
            // 需要转换为巴西时间格式的字段名列表
            const propArr = [
              'lastTrackTime',
              'createTime',
              'customerSendTime',
              'collectScanTime',
              'receiptTime',
              'sendTime',
              'deliverUploadScanTime',
              'dispatchReceiptTime',
              'lastDeliveryTime',
              'deliveredTime',
              'startDeliveryTime',
              'customerAgingEndTime',
              'customerSendTime'
            ];
            if (this.$i18n.locale !== 'zh') {
              // 转换时间格式
              this.tableData = res.data.records.map((item) => {
                for (const key in item) {
                  if (propArr.includes(key)) {
                    item[key] = item[key]
                      ? dayjs(item[key]).format('DD-MM-YYYY HH:mm:ss')
                      : item[key];
                  }
                }
                return item;
              });
            } else {
              this.tableData = res.data.records;
            }
            this.tableData.map((item) => {
              item.supplierName = item.providerChannelName;
            });
            if (val === 1) {
              loading.close();
            }
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.number = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.number = val;
      this.getSearch();
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      // const oneWeekAgo = dayjs(brazilTime).subtract(1, 'week').format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    /**
     * @description 分页获取客户列表
     * @param { string } name 客户名称
     */
    getCustomerPage(name = '', flag) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: ''
        }
      };
      if (flag) {
        if (this.customerList.length === 0) {
          apiCustomerPage(param).then((res) => {
            if (res.code === 200) {
              this.customerList = res.data.records;
            }
          });
        }
      } else {
        param.params.quickSearch = name;
        apiCustomerPage(param).then((res) => {
          if (res.code === 200) {
            this.customerList = res.data.records;
          }
        });
      }
    },
    // 获取运单时效的更新时间
    getLastSyncTimeData() {
      getLastSyncTime().then((res) => {
        if (res.code === 200) {
          this.lastSyncTime = res.data;
        }
      });
    },
    // 网点查询类型切换时重新加载网点列表
    onProviderTypeChange() {
      this.queryForm.params.siteDataId = null;
      this.queryForm.params.regionId = '';
      this.getRegionList();
    },
    // 获取所有大区列表
    getRegionList() {
      const isLatestTrackSite = this.queryForm.params.providerType === 4;
      const includeDisabled = isLatestTrackSite;
      // 最新轨迹网点：查询所有网点+转运中心（含已停用）；其他类型：仅查询网点
      const regionSiteType = isLatestTrackSite ? 3 : 1;
      regionQueryList(regionSiteType, includeDisabled).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data.map((item) => {
            if (item.sites && item.sites.length > 0) {
              item.sites = this.sortSites(item.sites);
            }
            return {
              ...item,
              name: this.$i18n.locale === 'zh' ? item.zhName : item.puName
            };
          });
        }
      });
    },
    sortSites(sites) {
      return sites.sort((a, b) => {
        const nameA = a.name || '';
        const nameB = b.name || '';
        if (!nameA && !nameB) return 0;
        if (!nameA) return 1;
        if (!nameB) return -1;
        // 以‘AL-W-A001’为例
        // 分三块
        const partsA = nameA.split('-');
        const partsB = nameB.split('-');
        if (partsA.length < 3 || partsB.length < 3) {
          return nameA.localeCompare(nameB);
        }
        // 1. 按第一个部分的第一个字母排序（AL-W-A001 中的 A）
        const firstLetterA = partsA[0].charAt(0);
        const firstLetterB = partsB[0].charAt(0);
        if (firstLetterA !== firstLetterB) {
          return firstLetterA.localeCompare(firstLetterB);
        }
        // 2. 如果第一个字母相同，比较第一个部分的第二个字母（AL-W-A001 中的 L）
        const secondLetterA = partsA[0].charAt(1);
        const secondLetterB = partsB[0].charAt(1);
        if (secondLetterA !== secondLetterB) {
          return secondLetterA.localeCompare(secondLetterB);
        }
        // 3. 如果前两个字母相同，比较第二个部分的第一个字母（AL-W-A001 中的 W）
        const thirdLetterA = partsA[1].charAt(0);
        const thirdLetterB = partsB[1].charAt(0);
        if (thirdLetterA !== thirdLetterB) {
          return thirdLetterA.localeCompare(thirdLetterB);
        }
        // 4. 如果前三字母相同，比较第三个部分的第一个字母（AL-W-A001 中的 A）
        const fourthLetterA = partsA[2].charAt(0);
        const fourthLetterB = partsB[2].charAt(0);
        if (fourthLetterA !== fourthLetterB) {
          return fourthLetterA.localeCompare(fourthLetterB);
        }
        // 5. 如果前四位字母相同，按数字部分排序（AL-W-A001 中的 001）
        const numberA = parseInt(partsA[2].substring(1)) || 0;
        const numberB = parseInt(partsB[2].substring(1)) || 0;
        if (numberA !== numberB) {
          return numberA - numberB;
        }
        return nameA.localeCompare(nameB); // localeCompare：默认按字符串排序
      });
    },
    // 获取对应的供应商下的网点
    getSupperSite(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteData = res.data;
        }
      });
    },
    changeInput(val) {
      this.$emit('input', val);
    },
    // 改变时间
    handleTime(val) {
      if (val) {
        const startDate = dayjs(val[0]);
        const endDate = dayjs(val[1]);
        // 计算天数差（取绝对值，确保顺序不影响结果）
        const daysDiff = Math.abs(endDate.diff(startDate, 'day'));
        // 判断是否超过31天
        const isOver31Days = daysDiff > 31;
        if (isOver31Days) {
          this.$message.error(this.$t('tablePrice.timeRangeLimit'));
          this.getTimer();
        }
      }
      this.queryForm.number = 1;
    },
    clearForm() {
      this.exportRuleForm.NumberType = '1';
      this.exportRuleForm.inputValeu = '';
    },
    selectStatus(val) {
      if (val.indexOf(0) !== -1) {
        this.queryForm.params.waybillStatus = [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22
        ];
      }
    },
    // 进入运单详情
    toOrderDetail(row) {
      this.queryTrackParam = row;
      this.waybillDescription = true;
      this.detailKey = new Date().getTime();
      setTimeout(() => {
        this.bus.$emit('todetailBox', row.waybillId);
      }, 100);
    },
    // 州
    getAddress() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 切换网点
    hanleSiteId(val) {
      console.log(val);
      // this.queryForm.params.regionId = val;
    }
  }
};
</script>

<style scoped>
.app-container >>> .el-dialog__body {
  padding: 10px 20px;
}

.app-container >>> .drawerClass header {
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 0 !important;
  padding: 20px 20px 20px !important;
}

.app-container >>> .el-form--label-top .el-form-item__label {
  width: 100% !important;
}

.app-container >>> .selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  padding: 0;
  font-weight: bold;
  text-align: left;
}

.app-container >>> .selectLabel .el-input__icon {
  line-height: 28px !important;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
}

.mini-filterable-cascader ::v-deep .el-cascader__tags .el-tag {
  /* 将 tag 的上下 margin 减小，给它更多空间 */
  margin: 3px 0 1px 6px;
  /* 如果需要，可以强制设置 tag 的高度 */
  /* height: 20px; */
}

/* 同时，可能需要微调过滤输入框的高度和位置，使其垂直居中 */
.mini-filterable-cascader ::v-deep .el-cascader__search-input {
  height: 24px; /* mini 尺寸输入框的内部高度 */
  line-height: 24px;
  margin: 1px 16px;
}
</style>
